import React from "react";
import Countdown from "../components/Countdown";
import Timeline from "../components/Timeline";
import Services from "../components/Services";
import Menu from "../components/Menu";

function Home({ setActivePage }) {
    return (
        <div className="page-home">

            {/* HERO */}
            <section className="hero">
                <div className="hero-left">
                    <div className="hero-eyebrow">Zapraszamy na nasze wesele</div>
                    <div className="hero-names">
                        <span className="name-line">Klaudia</span>
                        <span className="name-amp">&</span>
                        <span className="name-line name-italic">Bartłomiej</span>
                    </div>
                    <div className="hero-meta">
                        <div className="meta-box yellow">
                            <div className="meta-val">15 · 08 · 2026</div>
                            <div className="meta-label">Nasz dzień</div>
                        </div>
                        <div className="meta-box light">
                            <div className="meta-val">Hotel & Restauracja President</div>
</div>
                    </div>
                    <div className="hero-btns">
                        <button
                            className="btn-fill"
                            onClick={() => setActivePage("gallery")}
                        >
                            📸 Galeria Live
                        </button>
                        <button
                            className="btn-border"
                            onClick={() =>
                                document
                                    .getElementById("harmonogram")
                                    .scrollIntoView({ behavior: "smooth" })
                            }
                        >
                            Harmonogram ↓
                        </button>
                    </div>
                </div>
                <div className="hero-right">
                        <img
                            src="/hero.png"
                            alt="Klaudia i Bartłomiej"
                            className="hero-img"
                        />
                </div>
            </section>

            {/* ODLICZANIE */}
            <Countdown />

            {/* NASZA HISTORIA */}
            <div className="story">
                <div className="story-photos">
                    <img
                        src="/klaudia bartek.jpg"
                        alt="Klaudia i Bartłomiej"
                        className="story-photo-single"
                    />
                    <div className="story-badge">
                        <div className="badge-n">15</div>
                        <div className="badge-t">Sierpień</div>
                    </div>
                </div>
                <div>
                    <div className="eyebrow grape">Nasza historia</div>
                    <h2 className="sec-title">
                        Wszystko zaczęło się<br />
                        <em>pewnego letniego dnia…</em>
                    </h2>
                    <div className="sec-body">
                        <p>
                            Wszystko zaczęło się pewnego lipcowegi dnia…
                        </p>
                        <p>
                            Tak. Te dzieci wzięły ślub!
                        </p>
                        <p>
                            Te same dzieci, które pewnego zwykłego wieczoru siedziały z telefonem w ręku na Tinderze, zupełnie nieświadome, że właśnie zmieniają swoje życie na zawsze.
                        </p>
                        <p> A wszystko zaczęło się w Lublinie — mieście wielu pereł, z których, jak wiadomo, większość jest na eksport. 😉 Oboje pochodzimy z Lubelszczyzny, więc może los po prostu uznał, że czas połączyć tych dwoje w parę. </p>
                        <p>
                            Klaudia — farmaceutka. Bartłomiej — specjalista ds. IT. Ona potrafi znaleźć lekarstwo na prawie każdy problem, on wierzy, że większość rzeczy da się naprawić, wyłączając je i włączając ponownie. Jak widać, całkiem dobrze się uzupełniamy.
                        </p>
                        <p>Dziś mieszkamy w Warszawie, przy ulicy Alternatywy 4 . Przypadek? Być może. A może po prostu nasza historia od początku miała w sobie coś z dobrego serialu. 😄
                        </p>
                            <p>
                                Przez te cztery lata było wszystko, co najlepsze — mnóstwo śmiechu, wspólne wieczory, gry planszowe, a w szczególności „Wirus”, puzzle, które zawsze okazują się mieć o kilkaset elementów za dużo, oraz seanse na Netflixie, podczas których jedno z nas (a nawet obydwoje) zazwyczaj zasypia, zanim akcja zdąży się na dobre rozkręcić.
                            </p>
                        <p>
                            Mamy też całkiem sporą drużynę rodzinną. Bartłomiej ma dwóch braci, a Klaudia — trzy siostry i brata. Nasi rodzice — Karol i Agata oraz Adam i Bożena — mają z kolei coś bardzo ważnego wspólnego: wszyscy zajmują się rolnictwem. Można więc powiedzieć, że nasze rodzinne korzenie są naprawdę mocne. 🌱
                        </p>
                        <p>Zanim jednak przyszły zaręczyny, mieliśmy już okazję zaliczyć małą próbę generalną naszego własnego wesela.
                        </p>

                        <p>Podczas wesela siostry Klaudii stanęliśmy do oczepinowej walki o bukiet ślubny i muchę. I, ku zaskoczeniu chyba wszystkich, **wygraliśmy oboje!** 💐🎩
                        </p>

                        <p>Jakby tego było mało, mamy już za sobą także pierwszy taniec. Zatańczyliśmy wtedy do niezapomnianego hitu **„Jesteś szalona” zespołu Boys**.
                            .</p>

                        <p>Bukiet zdobyty.
                            Mucha zdobyta.
                            Pierwszy taniec odhaczony.</p>

                        <p> Pozostało tylko się pobrać. 😄 </p>

                        <p>Pewnego październikowego poranka Bartłomiej zabrał Klaudię nad morze. Wstaliśmy przed świtem, poszliśmy na plażę i gdy pierwsze promienie słońca dotknęły wody — ukląkł.
                        </p>

                        <p>Serce waliło jak szalone.
                            Klaudia płakała.
                            Bartłomiej też trochę.</p>

                        <p>Powiedziała „tak”. 💍</p>

                        <p>I teraz te dwoje dzieci stoi przed Wami — tymi samymi ludźmi, którzy towarzyszyli nam przez te wszystkie lata.
                        </p>

                        <p>Przed nami kolejny etap. Tym razem już naprawdę dorosły.</p>

                        <p>No dobrze… prawie dorosły.</p>

                        <p>Bo nadal będziemy układać puzzle, grać w „Wirusa”, zasypiać podczas Netflixa i — skoro pierwszy taniec mamy już za sobą — być może jeszcze nie raz zatańczymy „Jesteś szalona”. ❤️</p>

                       <p> Dziękujemy, że jesteście z nami w tym szalonym, pięknym i zupełnie dorosłym dniu.</p>

                        <p>❤️🧡🩷Klaudia & Bartłomiej🩷🧡❤️</p>

                    </div>
                </div>
            </div>

            <Menu />

            <Services />

            {/* HARMONOGRAM */}
            <Timeline />

            {/* LOKALIZACJA */}
            <div className="location">
                <div className="location-maps">

                    <div className="map-embed-wrap">
                        <div className="map-label">
                            <span className="map-label-icon">🗺</span>
                            Trasa — Kościół do Hotelu President
                        </div>
                        <iframe
                            className="map-iframe"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/directions?key=AIzaSyB_sjUO0IoipnUvqFMOgFRyx0NBrDqpFZU&origin=Gąsiory+28,+21-307+Ulan-Majorat,+Polska&destination=ul.+Józefa+Piłsudskiego+19,+Kock,+Polska&mode=driving`}
                            title="Trasa do hotelu"
                        />
                    </div>

                    <div className="map-embed-wrap">
                        <div className="map-label">
                            <span className="map-label-icon">🏨</span>
                            Hotel i Restauracja President — Kock
                        </div>
                        <iframe
                            className="map-iframe"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB_sjUO0IoipnUvqFMOgFRyx0NBrDqpFZU&q=ul.+Józefa+Piłsudskiego+19,+Kock,+Polska&zoom=16`}
                            title="Hotel President Kock"
                        />
                    </div>

                </div>

                <div>
                    <div className="eyebrow grape">Jak do nas trafić</div>

                    <div className="loc-card">
                        <div className="loc-label">⛪ Ceremonia</div>
                        <div className="loc-val">Parafia św. Andrzeja Boboli</div>
                        <div className="loc-sub">Gąsiory 28, 21-307 Ulan-Majorat · Godz. 15:00</div>
                    </div>

                    <div className="loc-card">
                        <div className="loc-label">🏨 Przyjęcie weselne</div>
                        <div className="loc-val">Hotel i Restauracja President</div>
                        <div className="loc-sub">ul. Józefa Piłsudskiego 19, Kock</div>
                    </div>

                    <div className="loc-card">
                        <div className="loc-label">🚗 Dystans</div>
                        <div className="loc-val">~25 minut jazdy</div>
                        <div className="loc-sub">Kościół → Hotel President</div>
                    </div>

                    <div className="nav-btns">

                       <a href="https://www.google.com/maps/dir/Gąsiory+28,+21-307+Ulan-Majorat/ul.+Józefa+Piłsudskiego+19,+Kock"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-fill"
                        style={{ textDecoration: "none" }}
                        >
                        🗺 Nawiguj — trasa
                    </a>

                   <a href="https://www.google.com/maps/search/ul.+Józefa+Piłsudskiego+19,+Kock"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-border"
                    style={{ textDecoration: "none" }}
                    >
                    📍 Hotel na mapie
                </a>
            </div>

        </div>
</div>

            {/* FOOTER */}
            <footer className="site-footer">
                <div className="footer-names">
                    Klaudia <span>&</span> Bartłomiej
                </div>
                <div className="footer-date">
                    15 · 08 · 2026 · Hotel & Restauracja President
                </div>
                <div className="footer-fruits">🍋 🧡 🍊 💛 🌿</div>
            </footer>

        </div>
    );
}

export default Home;